import type { Projection } from '@v2/sdk'

export function Rulebook({ projection }: { projection: Projection }) {
  return <div className="tt-rulebook"><p className="tt-rule-intro">{projection.game.description}</p>{projection.rules.map((rule, index) => <section className="tt-rule-section" key={`${index}-${rule.title}`}><span className="tt-rule-index">{String(index + 1).padStart(2, '0')}</span><div><h3>{rule.title}</h3><p>{rule.body}</p></div></section>)}</div>
}
